import * as Cookies from 'es-cookie';
import { v4 as uuidv4 } from 'uuid';
var SINGLE_PAGE_SESSION_ID = uuidv4();
export function getSinglePageSessionId() {
  return SINGLE_PAGE_SESSION_ID;
}
var THIRTY_MIN_IN_MILLISEC = 30 * 60 * 1000;

var setNewSessionId = function setNewSessionId(sessionId) {
  var now = Date.now();
  var expiryDate = new Date(now + THIRTY_MIN_IN_MILLISEC);
  var newCookie = {
    session_id: sessionId,
    timestamp: now
  };
  Cookies.set('glassbox-session-id', btoa(JSON.stringify(newCookie)), {
    expires: expiryDate
  });
  return newCookie.session_id;
};

export var getSessionId = function getSessionId() {
  var sessionIdCookie = Cookies.get('glassbox-session-id');
  var sessionId;

  if (sessionIdCookie == null) {
    sessionId = uuidv4();
  } else {
    var sessionCookie = JSON.parse(atob(sessionIdCookie));
    var earliestValidTime = Date.now() - THIRTY_MIN_IN_MILLISEC;
    sessionId = sessionCookie.timestamp >= earliestValidTime ? sessionCookie.session_id : uuidv4();
  }

  return setNewSessionId(sessionId);
};
export var getReferrerUrl = function getReferrerUrl() {
  return document.referrer;
};